import { defineStore } from 'pinia'
import { emitEventToVuexStore } from '@vue3/utils/common.js'

const commonStore = defineStore('commonStore', {
  state: () => ({
    isMobile: false,
    isTablet: false,
    showAppLoader: false,
    errorCode: '',
    registrationId: '',
    showOnboardingModal: false,
    showTenantPickerModal: false,
    isTenantAlreadySelected: false
  }),
  getters: {
    getIsMobile (state) {
      return state.isMobile
    },
    getIsTablet (state) {
      return state.isTablet
    }
  },
  actions: {
    setMobileDeviceStatus (status) {
      this.isMobile = status
    },
    setTabletDeviceStatus (status) {
      this.isTablet = status
    },
    setAppLoader (value) {
      emitEventToVuexStore('PINIA_SET_APP_LOADER', value)
    },
    setErrorCode (value) {
      this.errorCode = value
      emitEventToVuexStore('PINIA_AUTH_ERROR', value)
    },
    setRegistrationId (value) {
      this.registrationId = value
    },
    setAppLoaderFromVuex (value) {
      this.showAppLoader = value
    },
    setShowOnboardingModal (value) {
      this.showOnboardingModal = value
    },
    setShowTenantPickerModal ({ showModal, isTenantAlreadySelected }) {
      this.isTenantAlreadySelected = isTenantAlreadySelected
      this.showTenantPickerModal = showModal
    }
  }
})

export default commonStore
